var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({minWidth: _vm.$attrs['max-width'] + 'px'})},[(_vm.src)?_c('v-img',_vm._b({attrs:{"src":_vm.src},on:{"error":function($event){_vm.src = _vm.defaultImageUrl}}},'v-img',_vm.$attrs,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }